import { CheckSquare } from '@phosphor-icons/react';

export default CheckSquare;
